import PropTypes from 'prop-types';
import React from 'react';
import {map} from 'lodash';
import Dropdown from 'src/components/dropdown';
import Label from 'shared/components/label';
import {last6Years, lastNYearsOptions} from 'shared/utils';

const defaultYears = last6Years().map((year) => ({
  _id: year.toString(),
  value: parseInt(year, 10).toString(),
  text: year.toString(),
}));

class YearDropdown extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    onChange: PropTypes.func,
    years: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        text: PropTypes.string,
      })
    ),
    lastX: PropTypes.number, // how many years in the past to generate dropdown options for
    label: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    testId: PropTypes.string,
  };

  state = {
    calculatedYears: [],
  };

  componentDidMount() {
    if (this.props.lastX) {
      this.setState({
        calculatedYears: lastNYearsOptions(this.props.lastX),
      });
    } else if (this.props.years) {
      this.setState({calculatedYears: this.props.years});
    } else {
      this.setState({calculatedYears: defaultYears});
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.lastX !== nextProps.lastX && nextProps.lastX !== 0) {
      this.setState({
        calculatedYears: map(new Array(this.props.lastX), (val, index) => {
          const year = (new Date().getFullYear() - index).toString();
          return {_id: year, value: year, text: year};
        }),
      });
    }
  }

  static defaultProps = {
    years: defaultYears,
    label: 'Year',
    style: {
      marginBottom: 10,
    },
  };

  render() {
    const {label, onChange, required, disabled, value, error, testId} = this.props;

    return (
      <Label required={required}>
        {label}
        <Dropdown
          required={required}
          options={this.state.calculatedYears}
          value={value}
          error={error}
          cy="year-dropdown"
          testid={testId || 'year-dropdown'}
          onChange={onChange}
          disabled={disabled}
        />
      </Label>
    );
  }
}

export default YearDropdown;
